import type { RouterConfig } from "@nuxt/schema";

// Default Nuxt behaviour scrolls to the top of the page on every route change.
// Opening a dish is not a real page navigation, it only exists to give the
// product modal a shareable/crawlable URL:
//   - adhoc: app/pages/store/[slug].vue pushes the nested
//     /store/{slug}/product/{productSlug} route (different path, same slug param).
//   - premium: app/pages/premium/store/[slug].vue and premium/menu/[slug].vue
//     replace/push a `?product={id}` query on the SAME route (name unchanged).
// Either way, scrolling the customer back to the top of a long menu just to pop
// up a modal is wrong - and the same applies in reverse when the modal closes.
function baseRouteName(name: unknown): string | undefined {
  if (typeof name !== "string") return undefined;
  // Strip a nested "-product-productSlug" suffix so the adhoc store page and its
  // nested product route are treated as the same page.
  return name.replace(/-product-productslug$/i, "");
}

export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;

    const toSlug = to.params.slug;
    const fromSlug = from.params.slug;
    const toBase = baseRouteName(to.name);
    const fromBase = baseRouteName(from.name);

    if (toSlug && toSlug === fromSlug && toBase && toBase === fromBase) {
      return false;
    }

    return { top: 0 };
  },
};
